import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

const baseQuery = fetchBaseQuery({
  baseUrl: process.env.REACT_APP_API_URL,
  prepareHeaders: (headers) => {
    const token = localStorage.getItem("authtoken");
    if (token) {
      headers.set("Authorization", `Bearer ${token}`);
    }
    return headers;
  },
});

const baseQueryWithReauth = async (args, api, extraOptions) => {
  let result = await baseQuery(args, api, extraOptions);

  if (result.error && result.error.status === 401) {
    localStorage.removeItem("authtoken");
  }
  return result;
};

export const BranchApi = createApi({
  reducerPath: "BranchApi",
  baseQuery: baseQueryWithReauth,
  endpoints: (builder) => ({
    getBranchList: builder.query({
      query: (param) => ({
        url: `/accounts/list-branch-domain`,
        params: param

      }),
    }),
    getBranchListall: builder.query({
      query: (param) => ({
        url: `/accounts/list-branch`,
        params: param

      }),
    }),
    postBranch: builder.mutation({
      query: (data) => ({
        url: `/accounts/branch-create/`,
        method: "POST",
        body: data,
      }),
    }),
    deleteBranch: builder.mutation({
      query: (id) => {
        return {
          url: `/accounts/branch-delete/${id}/`,
          method: "DELETE",
        };
      },
    }),
    updateBranch: builder.mutation({
      query: ({ id, branchData }) => {
        console.log("asdfghjkl/zzzzz", branchData, "it sid is", id);
        return {
          url: `/accounts/branch-update/${id}/`,
          method: "PUT",
          body: branchData,
        };
      },
    }),
    getBranchListWithDomainId: builder.query({
      query: ({ domain_id }) => {
        return {
          url: `/accounts/list-branch-superuser-view/${domain_id}/`,
        };
      },
    }),
  }),
});

export const {
  useGetBranchListallQuery,
  useGetBranchListQuery,
  usePostBranchMutation,
  useDeleteBranchMutation,
  useUpdateBranchMutation,
  useGetBranchListWithDomainIdQuery,
} = BranchApi;
